<template>
    <button
        type="button"
        role="button"
        class="o-w-services-tile w-services-tile"
        @click="onClick"
    >
        <span class="w-services-tile__icon-container">
            <img
                v-if="t(item, 'icon')"
                :src="t(item, 'icon')"
                :alt="`Image ${t(item, 'name')}`"
                class="w-services-tile__icon"
            >
        </span>
        <span class="w-services-tile__title">
            {{ t(item, 'name') }}
        </span>
        <span class="w-services-tile__info">
            {{ t(item, 'objectsCount') }} st
        </span>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'OWServicesTile',
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters([
            't'
        ])
    },
    methods: {
        onClick() {
            const params = {
                ...this.item,
                serviceCategory: true
            };
            this.$emit('onClick', params);
        }
    }
}
</script>

<style lang="scss">
@import "o-w-services-tile";
</style>